import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Tabs } from 'antd'
import * as React from 'react'
import { useRatebookDrillIn } from './hooks'
import { BackButton, BillingInfo, BillingStatusBanner, RatebookHeader } from './components'
import { AutomaticAccessorialsTab } from './tabs/AutomaticAccessorials'
import { BaseFreightTab } from './tabs/BaseFreight'
import { InvoiceConfigurationTab } from './tabs/InvoiceConfig'
import { ManualAccessorialsTab } from './tabs/ManualAccessorials'
import { PointToPointTab } from './tabs/PointToPoint'
import { SurchargeTab } from './tabs/Surcharge'

const { TabPane } = Tabs

export function RatebookDrillIn() {
  const { selectedRatebook, isLoading, invoiceStatus, setInvoiceStatus, activeTab, handleTabChange } =
    useRatebookDrillIn()

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (!selectedRatebook) {
    return (
      <Vertical flex={1} horizontalCenter verticalCenter>
        <Texto category='h4'>Ratebook not found</Texto>
        <BackButton />
      </Vertical>
    )
  }

  const tabs = [
    {
      key: 'invoice-configuration',
      label: 'Ratebook Configuration',
      children: (
        <InvoiceConfigurationTab
          ratebook={selectedRatebook}
          invoiceStatus={invoiceStatus}
          onChange={(field, value) => {
            if (field === 'invoice_status') {
              setInvoiceStatus(value as string)
            }
          }}
        />
      ),
    },
    {
      key: 'base-freight',
      label: 'Freight Tables',
      children: <BaseFreightTab ratebook={selectedRatebook} />,
    },
    {
      key: 'point-to-point',
      label: 'Point to Point',
      children: <PointToPointTab ratebook={selectedRatebook} />,
    },
    {
      key: 'automatic-accessorials',
      label: 'Automatic Accessorials',
      children: <AutomaticAccessorialsTab ratebook={selectedRatebook} />,
    },
    {
      key: 'manual-accessorials',
      label: 'Manual Accessorials',
      children: <ManualAccessorialsTab ratebook={selectedRatebook} />,
    },
    {
      key: 'surcharge',
      label: 'Surcharge',
      children: <SurchargeTab ratebook={selectedRatebook} />,
    },
  ]

  return (
    <Vertical border='all' borderRadius='6px' style={{ overflow: 'auto', minHeight: 0 }}>
      <Vertical flex='0' style={{ overflow: 'visible' }} bg='elevated' border='bottom'>
        <BackButton bookType={selectedRatebook.book_type} />
      </Vertical>
      <Vertical bg='elevated'>
        <Horizontal border='bottom' bg='default' className='p-3' verticalCenter>
          <RatebookHeader ratebook={selectedRatebook} />
          <BillingInfo ratebook={selectedRatebook} />
          <BillingStatusBanner status={selectedRatebook.invoice_status} ratebook={selectedRatebook} />
        </Horizontal>

        <Vertical flex={1} style={{ overflow: 'auto', minHeight: 0 }}>
          <Tabs
            style={{ flex: 1, backgroundColor: 'var(--gray-100)' }}
            className='px-3'
            activeKey={activeTab || undefined}
            onChange={handleTabChange}
          >
            {tabs.map((tab) => (
              <TabPane tab={tab.label} key={tab.key}>
                {tab.children}
              </TabPane>
            ))}
          </Tabs>
        </Vertical>
      </Vertical>
    </Vertical>
  )
}
